export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmYUtfABc4AMP6lbBP.7a8b8d60.woff2";